export const PROJECTS_QUERY_ITEM_LIMIT = 30;
export const PROJECTS_PER_PAGE = 6;
